
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface PlansHeaderProps {
  language: Language;
  onClose: () => void;
}

const PlansHeader: React.FC<PlansHeaderProps> = ({ language, onClose }) => {
  const t = TRANSLATIONS[language];
  return (
    <div className="px-6 py-5 bg-white dark:bg-[#15151a] border-b border-slate-100 dark:border-white/5 flex items-center justify-between shrink-0">
      <div className="flex items-center gap-3">
         <div className="w-8 h-8 rounded-xl bg-emerald-500/10 flex items-center justify-center text-emerald-500">
            <i className="fas fa-crown text-xs"></i>
         </div>
         <div>
           <h2 className="text-sm font-black text-slate-800 dark:text-white">{t.plansTitle}</h2>
           <p className="text-[10px] text-slate-400 font-bold opacity-80">{t.plansSubtitle}</p>
         </div>
      </div>
      <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-50 dark:bg-white/5 hover:bg-slate-100 text-slate-400 transition-all">
        <i className="fas fa-times text-xs"></i>
      </button>
    </div>
  );
};

export default PlansHeader;
